/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";
const useMedicalConditions = (companion) => {
  /* const { t } = useTranslation(); */
  const [isSubmitEnabled, setSubmitEnabled] = useState(false);

  const BLOOD_TYPES = [
    "O_plus",
    "O_minus",
    "A_plus",
    "A_minus",
    "B_plus",
    "B_minus",
    "AB_plus",
    "AB_minus",
  ];

  const [formData, setFormData] = useState(() =>
    BLOOD_TYPES.reduce((sum, key) => {
      return { ...sum, [key]: { state: "initial", value: key } };
    }, {})
  );
  const [medicalConditions, setMedicalConditions] = useState("");
  const [spcialAssistanc, setSpecialAssistance] = useState("");

  const updateFormData = (bloodType) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };

      Object.keys(updatedFormData).forEach((key) => {
        if (key === bloodType) {
          updatedFormData[key] = { state: "success", value: bloodType };
        } else {
          updatedFormData[key] = {
            state: "initial",
            value: updatedFormData[key].value,
          };
        }
      });

      return updatedFormData;
    });
  };
  useEffect(() => {
    if (!companion) return;

    updateFormData(companion.blood_type);
    setMedicalConditions(companion.medical_conditions);
    setSpecialAssistance(companion.special_medical_assistance);
  }, [companion]);

  const handleOnChange = (text) => {
    updateFormData(text);
  };

  return {
    medicalConditions,
    setMedicalConditions,
    setSpecialAssistance,
    spcialAssistanc,
    isSubmitEnabled,
    handleOnChange,
    formData,
  };
};

export default useMedicalConditions;
